import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import OtpVerification from "@/_MiniApps/auth/ui/OTP/OtpVerification";
import useHelpers from "@hooks/useHelpers";
import FLowLoadingSpinner from "@/pages/sell-my-car/components/FLowLoadingSpinner";
var TabbyOTPStep = function TabbyOTPStep(_ref) {
  var userInfo = _ref.userInfo,
    onVerified = _ref.onVerified,
    post_id = _ref.post_id,
    financestep = _ref.financestep;
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4 md:p-0 h-full relative"
  }, /*#__PURE__*/React.createElement(OtpVerification, {
    FIX_ME__extra_params: {
      is_finance: true
    },
    source: "finance_order_verify",
    after_verify_callback: onVerified,
    scenario: "signup",
    phone_number: userInfo.mobile_number,
    onEditNumber: function onEditNumber() {
      navigateToHard("/finance-apply-tabby", {
        post_id: post_id,
        financestep: 1
      });
    },
    design: {
      className: "",
      btnText: tShort("phone_number_verification", {
        ns: "otp_screen"
      }),
      label: tShort("enter_code_sent_to", {
        ns: "otp_screen"
      }),
      withborder: false
    },
    LoaderComponent: /*#__PURE__*/React.createElement("div", {
      className: "min-h-[600px] flex items-center justify-center"
    }, /*#__PURE__*/React.createElement(FLowLoadingSpinner, null))
  }));
};
export default TabbyOTPStep;